import { SiesaMonitoring } from "../modules/siesaMonitoring/ui/SiesaMonitoring";

export const SiesaMonitoringPage = () => {
  return <SiesaMonitoring />;
};
